module.exports = __webpack_public_path__ + "static/img/home_05.815f03c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/home_05.png
// module id = uB7+
// module chunks = 34